import { atom } from "recoil";

export const defaultLoginFormState = {
    usrNm : "",
    cstmOfcrNo : "",
    usrEmlAddr : "", 
    isLcm : false
};
const findIdFormState = atom<{
    usrNm: string;
    cstmOfcrNo: string;
    usrEmlAddr: string;
    isLcm : boolean;
}>({
    key: "findIdFormState",
    default: defaultLoginFormState,
});

export default findIdFormState;
